// extracted by mini-css-extract-plugin
export default {"container":"PromoCodesGroupParameters_container__zlTdj","textinput":"PromoCodesGroupParameters_textinput__A4RCC"};